import { AppState } from '../../../types';

export const selectHasShareholder = (state: AppState) => {
  return state.shareholder.hasShareholder;
};
